<!--

    Copyright (c) 2017-present, Siklu Ltd.
    All rights reserved.

-->
<span *ngIf="currentPrice > 0" class="float-left ml-1">{{ symbol }}</span>
<span class="float-right ml-1">
    {{ currentPrice === -1 ? 'on-demand' : (currentPrice | number: '1.2-2') }}
</span>
